module.exports = __webpack_public_path__ + "static/media/competitionKit.46d8d9a6.mp4";